/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import {
  HumanErrorDamageType,
  OosTicketMaintenanceType,
  OosTicketStatusType,
  OpportunityMXType,
  OutOfServiceType,
  RtsDelayReasonType,
} from 'src/graphql/generated/graphql.generated';
import {
  IdListItemRecord,
  IdListItemProps,
} from 'src/store/generated/id-list-item-record.generated';
import { AddressRecord, AddressProps } from 'src/store/generated/address-record.generated';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface OutOfServiceTicketProps {
  id: string;
  ticketNumber: string | null;
  businessUnitCompanyId: string | null;
  isPlanned: boolean;
  maintenanceTypes: Set<OosTicketMaintenanceType>;
  vehicleId: string;
  assignedBaseId: string | null;
  maintenanceLocation: string | null;
  outOfServiceTime: Date;
  ertsDateTime: Date;
  submittedById: string;
  dateSubmittedForReview: Date | null;
  pointOfContactId: string | null;
  alternatePOC: string | null;
  ticketDescription: string;
  spareVehicleId: string | null;
  isBirdStrike: boolean;
  isPatientOnboard: boolean;
  opportunityMXTypes: Set<OpportunityMXType> | null;
  mxDuringPeakTimeReason: string | null;
  waitingForParts: boolean;
  waitingForTooling: boolean;
  waitingForPartsTimestamp: Date | null;
  waitingForToolingTimestamp: Date | null;
  isAMTAvailable: boolean | null;
  isFAR135415Reportable: boolean | null;
  isFAR135417Reportable: boolean | null;
  acceptedById: string | null;
  dateAccepted: Date | null;
  humanErrorDamageType: HumanErrorDamageType | null;
  qarReasons: List<IdListItemProps> | null;
  rtsDelayReasonTypes: Set<RtsDelayReasonType> | null;
  pageoutCompletedById: string | null;
  datePageoutCompleted: Date | null;
  status: OosTicketStatusType;
  primaryReasonId: string | null;
  secondaryReasonId: string | null;
  outOfServiceType: OutOfServiceType | null;
  dateAcknowledged: Date | null;
  acknowledgedById: string | null;
  acknowledgementNotes: string | null;
  maintenanceFacilityId: string | null;
  locationId: string | null;
  address: AddressProps | null;
  isOpportunisticOOS: boolean | null;
  companyId: string;
  dateLastUpdated: Date;
  dateCreated: Date;
  dateDeleted: Date | null;
  lastUpdatedById: string | null;
}

export class OutOfServiceTicketRecord extends Record<OutOfServiceTicketProps>({
  id: null as any,
  ticketNumber: null as any,
  businessUnitCompanyId: null as any,
  isPlanned: null as any,
  maintenanceTypes: null as any,
  vehicleId: null as any,
  assignedBaseId: null as any,
  maintenanceLocation: null as any,
  outOfServiceTime: null as any,
  ertsDateTime: null as any,
  submittedById: null as any,
  dateSubmittedForReview: null as any,
  pointOfContactId: null as any,
  alternatePOC: null as any,
  ticketDescription: null as any,
  spareVehicleId: null as any,
  isBirdStrike: null as any,
  isPatientOnboard: null as any,
  opportunityMXTypes: null as any,
  mxDuringPeakTimeReason: null as any,
  waitingForParts: null as any,
  waitingForTooling: null as any,
  waitingForPartsTimestamp: null as any,
  waitingForToolingTimestamp: null as any,
  isAMTAvailable: null as any,
  isFAR135415Reportable: null as any,
  isFAR135417Reportable: null as any,
  acceptedById: null as any,
  dateAccepted: null as any,
  humanErrorDamageType: null as any,
  qarReasons: null as any,
  rtsDelayReasonTypes: null as any,
  pageoutCompletedById: null as any,
  datePageoutCompleted: null as any,
  status: null as any,
  primaryReasonId: null as any,
  secondaryReasonId: null as any,
  outOfServiceType: null as any,
  dateAcknowledged: null as any,
  acknowledgedById: null as any,
  acknowledgementNotes: null as any,
  maintenanceFacilityId: null as any,
  locationId: null as any,
  address: null as any,
  isOpportunisticOOS: null as any,
  companyId: null as any,
  dateLastUpdated: null as any,
  dateCreated: null as any,
  dateDeleted: null as any,
  lastUpdatedById: null as any,
}) {
  public static fromJS(json: {
    id: string;
    ticketNumber: string | null;
    businessUnitCompanyId: string | null;
    isPlanned: boolean;
    maintenanceTypes: any;
    vehicleId: string;
    assignedBaseId: string | null;
    maintenanceLocation: string | null;
    outOfServiceTime: string | number | Date;
    ertsDateTime: string | number | Date;
    submittedById: string;
    dateSubmittedForReview: string | number | Date | null;
    pointOfContactId: string | null;
    alternatePOC: string | null;
    ticketDescription: string;
    spareVehicleId: string | null;
    isBirdStrike: boolean;
    isPatientOnboard: boolean;
    opportunityMXTypes: any;
    mxDuringPeakTimeReason: string | null;
    waitingForParts: boolean;
    waitingForTooling: boolean;
    waitingForPartsTimestamp: string | number | Date | null;
    waitingForToolingTimestamp: string | number | Date | null;
    isAMTAvailable: boolean | null;
    isFAR135415Reportable: boolean | null;
    isFAR135417Reportable: boolean | null;
    acceptedById: string | null;
    dateAccepted: string | number | Date | null;
    humanErrorDamageType: HumanErrorDamageType | null;
    qarReasons: any;
    rtsDelayReasonTypes: any;
    pageoutCompletedById: string | null;
    datePageoutCompleted: string | number | Date | null;
    status: OosTicketStatusType;
    primaryReasonId: string | null;
    secondaryReasonId: string | null;
    outOfServiceType: OutOfServiceType | null;
    dateAcknowledged: string | number | Date | null;
    acknowledgedById: string | null;
    acknowledgementNotes: string | null;
    maintenanceFacilityId: string | null;
    locationId: string | null;
    address: any;
    isOpportunisticOOS: boolean | null;
    companyId: string;
    dateLastUpdated: string | number | Date;
    dateCreated: string | number | Date;
    dateDeleted: string | number | Date | null;
    lastUpdatedById: string | null;
  }): OutOfServiceTicketRecord {
    if (json == null) {
      throw new Error('OutOfServiceTicketRecord.fromJS: parameter cannot be null');
    }
    return new OutOfServiceTicketRecord({
      id: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
        'OutOfServiceTicketJson.id',
      ),
      ticketNumber: json.ticketNumber,
      businessUnitCompanyId: json.businessUnitCompanyId,
      isPlanned: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'isPlanned', false),
        'OutOfServiceTicketJson.isPlanned',
      ),
      maintenanceTypes: Set<OosTicketMaintenanceType>(
        getFromOrThrow(json, (j) => j.maintenanceTypes, 'OutOfServiceTicketJson.maintenanceTypes'),
      ),
      vehicleId: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'vehicleId', '00000000-0000-0000-0000-000000000000'),
        'OutOfServiceTicketJson.vehicleId',
      ),
      assignedBaseId: json.assignedBaseId,
      maintenanceLocation: json.maintenanceLocation,
      outOfServiceTime: new Date(
        getFromOrThrow(
          json,
          (j) => propValueOrDefault(j, 'outOfServiceTime', '0001-01-01T00:00:00.00Z'),
          'OutOfServiceTicketJson.outOfServiceTime',
        ),
      ),
      ertsDateTime: new Date(
        getFromOrThrow(
          json,
          (j) => propValueOrDefault(j, 'ertsDateTime', '0001-01-01T00:00:00.00Z'),
          'OutOfServiceTicketJson.ertsDateTime',
        ),
      ),
      submittedById: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'submittedById', '00000000-0000-0000-0000-000000000000'),
        'OutOfServiceTicketJson.submittedById',
      ),
      dateSubmittedForReview:
        json.dateSubmittedForReview != null ? new Date(json.dateSubmittedForReview) : null,
      pointOfContactId: json.pointOfContactId,
      alternatePOC: json.alternatePOC,
      ticketDescription: getFromOrThrow(
        json,
        (j) => j.ticketDescription,
        'OutOfServiceTicketJson.ticketDescription',
      ),
      spareVehicleId: json.spareVehicleId,
      isBirdStrike: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'isBirdStrike', false),
        'OutOfServiceTicketJson.isBirdStrike',
      ),
      isPatientOnboard: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'isPatientOnboard', false),
        'OutOfServiceTicketJson.isPatientOnboard',
      ),
      opportunityMXTypes:
        json.opportunityMXTypes != null ? Set<OpportunityMXType>(json.opportunityMXTypes) : null,
      mxDuringPeakTimeReason: json.mxDuringPeakTimeReason,
      waitingForParts: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'waitingForParts', false),
        'OutOfServiceTicketJson.waitingForParts',
      ),
      waitingForTooling: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'waitingForTooling', false),
        'OutOfServiceTicketJson.waitingForTooling',
      ),
      waitingForPartsTimestamp:
        json.waitingForPartsTimestamp != null ? new Date(json.waitingForPartsTimestamp) : null,
      waitingForToolingTimestamp:
        json.waitingForToolingTimestamp != null ? new Date(json.waitingForToolingTimestamp) : null,
      isAMTAvailable: json.isAMTAvailable,
      isFAR135415Reportable: json.isFAR135415Reportable,
      isFAR135417Reportable: json.isFAR135417Reportable,
      acceptedById: json.acceptedById,
      dateAccepted: json.dateAccepted != null ? new Date(json.dateAccepted) : null,
      humanErrorDamageType: json.humanErrorDamageType,
      qarReasons:
        json.qarReasons != null
          ? List<IdListItemRecord>(json.qarReasons.map((o: any) => new IdListItemRecord(o)))
          : null,
      rtsDelayReasonTypes:
        json.rtsDelayReasonTypes != null ? Set<RtsDelayReasonType>(json.rtsDelayReasonTypes) : null,
      pageoutCompletedById: json.pageoutCompletedById,
      datePageoutCompleted:
        json.datePageoutCompleted != null ? new Date(json.datePageoutCompleted) : null,
      status: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'status', OosTicketStatusType.Draft),
        'OutOfServiceTicketJson.status',
      ),
      primaryReasonId: json.primaryReasonId,
      secondaryReasonId: json.secondaryReasonId,
      outOfServiceType: json.outOfServiceType,
      dateAcknowledged: json.dateAcknowledged != null ? new Date(json.dateAcknowledged) : null,
      acknowledgedById: json.acknowledgedById,
      acknowledgementNotes: json.acknowledgementNotes,
      maintenanceFacilityId: json.maintenanceFacilityId,
      locationId: json.locationId,
      address: json.address != null ? new AddressRecord(json.address) : null,
      isOpportunisticOOS: json.isOpportunisticOOS,
      companyId: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'companyId', '00000000-0000-0000-0000-000000000000'),
        'OutOfServiceTicketJson.companyId',
      ),
      dateLastUpdated: new Date(json.dateLastUpdated),
      dateCreated: new Date(json.dateCreated),
      dateDeleted: json.dateDeleted != null ? new Date(json.dateDeleted) : null,
      lastUpdatedById: json.lastUpdatedById,
    });
  }

  public static fromJSUnsafe(json: {
    id: string;
    ticketNumber: string | null;
    businessUnitCompanyId: string | null;
    isPlanned: boolean;
    maintenanceTypes: any;
    vehicleId: string;
    assignedBaseId: string | null;
    maintenanceLocation: string | null;
    outOfServiceTime: string | number | Date;
    ertsDateTime: string | number | Date;
    submittedById: string;
    dateSubmittedForReview: string | number | Date | null;
    pointOfContactId: string | null;
    alternatePOC: string | null;
    ticketDescription: string;
    spareVehicleId: string | null;
    isBirdStrike: boolean;
    isPatientOnboard: boolean;
    opportunityMXTypes: any;
    mxDuringPeakTimeReason: string | null;
    waitingForParts: boolean;
    waitingForTooling: boolean;
    waitingForPartsTimestamp: string | number | Date | null;
    waitingForToolingTimestamp: string | number | Date | null;
    isAMTAvailable: boolean | null;
    isFAR135415Reportable: boolean | null;
    isFAR135417Reportable: boolean | null;
    acceptedById: string | null;
    dateAccepted: string | number | Date | null;
    humanErrorDamageType: HumanErrorDamageType | null;
    qarReasons: any;
    rtsDelayReasonTypes: any;
    pageoutCompletedById: string | null;
    datePageoutCompleted: string | number | Date | null;
    status: OosTicketStatusType;
    primaryReasonId: string | null;
    secondaryReasonId: string | null;
    outOfServiceType: OutOfServiceType | null;
    dateAcknowledged: string | number | Date | null;
    acknowledgedById: string | null;
    acknowledgementNotes: string | null;
    maintenanceFacilityId: string | null;
    locationId: string | null;
    address: any;
    isOpportunisticOOS: boolean | null;
    companyId: string;
    dateLastUpdated: string | number | Date;
    dateCreated: string | number | Date;
    dateDeleted: string | number | Date | null;
    lastUpdatedById: string | null;
  }): [OutOfServiceTicketRecord, Error[]] {
    if (json == null) {
      throw new Error('OutOfServiceTicketRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new OutOfServiceTicketRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      id: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
            'OutOfServiceTicketJson.id',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ticketNumber: tryOrDefault(
        () => json.ticketNumber,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      businessUnitCompanyId: tryOrDefault(
        () => json.businessUnitCompanyId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      isPlanned: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'isPlanned', false),
            'OutOfServiceTicketJson.isPlanned',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      maintenanceTypes: tryOrDefault(
        () =>
          Set<OosTicketMaintenanceType>(
            getFromOrThrow(
              json,
              (j) => j.maintenanceTypes,
              'OutOfServiceTicketJson.maintenanceTypes',
            ),
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      vehicleId: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'vehicleId', '00000000-0000-0000-0000-000000000000'),
            'OutOfServiceTicketJson.vehicleId',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      assignedBaseId: tryOrDefault(
        () => json.assignedBaseId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      maintenanceLocation: tryOrDefault(
        () => json.maintenanceLocation,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      outOfServiceTime: tryOrDefault(
        () =>
          new Date(
            getFromOrThrow(
              json,
              (j) => propValueOrDefault(j, 'outOfServiceTime', '0001-01-01T00:00:00.00Z'),
              'OutOfServiceTicketJson.outOfServiceTime',
            ),
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ertsDateTime: tryOrDefault(
        () =>
          new Date(
            getFromOrThrow(
              json,
              (j) => propValueOrDefault(j, 'ertsDateTime', '0001-01-01T00:00:00.00Z'),
              'OutOfServiceTicketJson.ertsDateTime',
            ),
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      submittedById: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'submittedById', '00000000-0000-0000-0000-000000000000'),
            'OutOfServiceTicketJson.submittedById',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      dateSubmittedForReview: tryOrDefault(
        () => (json.dateSubmittedForReview != null ? new Date(json.dateSubmittedForReview) : null),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      pointOfContactId: tryOrDefault(
        () => json.pointOfContactId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      alternatePOC: tryOrDefault(
        () => json.alternatePOC,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ticketDescription: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => j.ticketDescription,
            'OutOfServiceTicketJson.ticketDescription',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      spareVehicleId: tryOrDefault(
        () => json.spareVehicleId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      isBirdStrike: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'isBirdStrike', false),
            'OutOfServiceTicketJson.isBirdStrike',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      isPatientOnboard: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'isPatientOnboard', false),
            'OutOfServiceTicketJson.isPatientOnboard',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      opportunityMXTypes: tryOrDefault(
        () =>
          json.opportunityMXTypes != null ? Set<OpportunityMXType>(json.opportunityMXTypes) : null,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      mxDuringPeakTimeReason: tryOrDefault(
        () => json.mxDuringPeakTimeReason,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      waitingForParts: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'waitingForParts', false),
            'OutOfServiceTicketJson.waitingForParts',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      waitingForTooling: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'waitingForTooling', false),
            'OutOfServiceTicketJson.waitingForTooling',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      waitingForPartsTimestamp: tryOrDefault(
        () =>
          json.waitingForPartsTimestamp != null ? new Date(json.waitingForPartsTimestamp) : null,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      waitingForToolingTimestamp: tryOrDefault(
        () =>
          json.waitingForToolingTimestamp != null
            ? new Date(json.waitingForToolingTimestamp)
            : null,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      isAMTAvailable: tryOrDefault(
        () => json.isAMTAvailable,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      isFAR135415Reportable: tryOrDefault(
        () => json.isFAR135415Reportable,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      isFAR135417Reportable: tryOrDefault(
        () => json.isFAR135417Reportable,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      acceptedById: tryOrDefault(
        () => json.acceptedById,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      dateAccepted: tryOrDefault(
        () => (json.dateAccepted != null ? new Date(json.dateAccepted) : null),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      humanErrorDamageType: tryOrDefault(
        () => json.humanErrorDamageType,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      qarReasons: tryOrDefault(
        () =>
          json.qarReasons != null
            ? List<IdListItemRecord>(json.qarReasons.map((o: any) => new IdListItemRecord(o)))
            : null,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      rtsDelayReasonTypes: tryOrDefault(
        () =>
          json.rtsDelayReasonTypes != null
            ? Set<RtsDelayReasonType>(json.rtsDelayReasonTypes)
            : null,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      pageoutCompletedById: tryOrDefault(
        () => json.pageoutCompletedById,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      datePageoutCompleted: tryOrDefault(
        () => (json.datePageoutCompleted != null ? new Date(json.datePageoutCompleted) : null),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      status: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'status', OosTicketStatusType.Draft),
            'OutOfServiceTicketJson.status',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      primaryReasonId: tryOrDefault(
        () => json.primaryReasonId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      secondaryReasonId: tryOrDefault(
        () => json.secondaryReasonId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      outOfServiceType: tryOrDefault(
        () => json.outOfServiceType,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      dateAcknowledged: tryOrDefault(
        () => (json.dateAcknowledged != null ? new Date(json.dateAcknowledged) : null),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      acknowledgedById: tryOrDefault(
        () => json.acknowledgedById,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      acknowledgementNotes: tryOrDefault(
        () => json.acknowledgementNotes,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      maintenanceFacilityId: tryOrDefault(
        () => json.maintenanceFacilityId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      locationId: tryOrDefault(
        () => json.locationId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      address: tryOrDefault(
        () => (json.address != null ? new AddressRecord(json.address) : null),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      isOpportunisticOOS: tryOrDefault(
        () => json.isOpportunisticOOS,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      companyId: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'companyId', '00000000-0000-0000-0000-000000000000'),
            'OutOfServiceTicketJson.companyId',
          ),
        (err) => errors.push(err),
      )!,
      dateLastUpdated: new Date(json.dateLastUpdated),
      dateCreated: new Date(json.dateCreated),
      dateDeleted: json.dateDeleted != null ? new Date(json.dateDeleted) : null,
      lastUpdatedById: json.lastUpdatedById,
    });

    return [record, errors];
  }

  constructor(props: OutOfServiceTicketProps) {
    super(props);
    if (props == null) {
      throw new Error('OutOfServiceTicketRecord constructor parameter cannot be null');
    }
  }
}

export abstract class OutOfServiceTicketViewModelBase implements OutOfServiceTicketProps {
  protected readonly _props: OutOfServiceTicketProps;
  private _json?: OutOfServiceTicketProps;

  get id(): string {
    return this._props.id;
  }
  get ticketNumber(): string | null {
    return this._props.ticketNumber;
  }
  get businessUnitCompanyId(): string | null {
    return this._props.businessUnitCompanyId;
  }
  get isPlanned(): boolean {
    return this._props.isPlanned;
  }
  get maintenanceTypes(): Set<OosTicketMaintenanceType> {
    return this._props.maintenanceTypes;
  }
  get vehicleId(): string {
    return this._props.vehicleId;
  }
  get assignedBaseId(): string | null {
    return this._props.assignedBaseId;
  }
  get maintenanceLocation(): string | null {
    return this._props.maintenanceLocation;
  }
  get outOfServiceTime(): Date {
    return this._props.outOfServiceTime;
  }
  get ertsDateTime(): Date {
    return this._props.ertsDateTime;
  }
  get submittedById(): string {
    return this._props.submittedById;
  }
  get dateSubmittedForReview(): Date | null {
    return this._props.dateSubmittedForReview;
  }
  get pointOfContactId(): string | null {
    return this._props.pointOfContactId;
  }
  get alternatePOC(): string | null {
    return this._props.alternatePOC;
  }
  get ticketDescription(): string {
    return this._props.ticketDescription;
  }
  get spareVehicleId(): string | null {
    return this._props.spareVehicleId;
  }
  get isBirdStrike(): boolean {
    return this._props.isBirdStrike;
  }
  get isPatientOnboard(): boolean {
    return this._props.isPatientOnboard;
  }
  get opportunityMXTypes(): Set<OpportunityMXType> | null {
    return this._props.opportunityMXTypes;
  }
  get mxDuringPeakTimeReason(): string | null {
    return this._props.mxDuringPeakTimeReason;
  }
  get waitingForParts(): boolean {
    return this._props.waitingForParts;
  }
  get waitingForTooling(): boolean {
    return this._props.waitingForTooling;
  }
  get waitingForPartsTimestamp(): Date | null {
    return this._props.waitingForPartsTimestamp;
  }
  get waitingForToolingTimestamp(): Date | null {
    return this._props.waitingForToolingTimestamp;
  }
  get isAMTAvailable(): boolean | null {
    return this._props.isAMTAvailable;
  }
  get isFAR135415Reportable(): boolean | null {
    return this._props.isFAR135415Reportable;
  }
  get isFAR135417Reportable(): boolean | null {
    return this._props.isFAR135417Reportable;
  }
  get acceptedById(): string | null {
    return this._props.acceptedById;
  }
  get dateAccepted(): Date | null {
    return this._props.dateAccepted;
  }
  get humanErrorDamageType(): HumanErrorDamageType | null {
    return this._props.humanErrorDamageType;
  }
  get qarReasons(): List<IdListItemProps> | null {
    return this._props.qarReasons;
  }
  get rtsDelayReasonTypes(): Set<RtsDelayReasonType> | null {
    return this._props.rtsDelayReasonTypes;
  }
  get pageoutCompletedById(): string | null {
    return this._props.pageoutCompletedById;
  }
  get datePageoutCompleted(): Date | null {
    return this._props.datePageoutCompleted;
  }
  get status(): OosTicketStatusType {
    return this._props.status;
  }
  get primaryReasonId(): string | null {
    return this._props.primaryReasonId;
  }
  get secondaryReasonId(): string | null {
    return this._props.secondaryReasonId;
  }
  get outOfServiceType(): OutOfServiceType | null {
    return this._props.outOfServiceType;
  }
  get dateAcknowledged(): Date | null {
    return this._props.dateAcknowledged;
  }
  get acknowledgedById(): string | null {
    return this._props.acknowledgedById;
  }
  get acknowledgementNotes(): string | null {
    return this._props.acknowledgementNotes;
  }
  get maintenanceFacilityId(): string | null {
    return this._props.maintenanceFacilityId;
  }
  get locationId(): string | null {
    return this._props.locationId;
  }
  get address(): AddressProps | null {
    return this._props.address;
  }
  get isOpportunisticOOS(): boolean | null {
    return this._props.isOpportunisticOOS;
  }
  get companyId(): string {
    return this._props.companyId;
  }

  get dateCreated(): Date {
    return this._props.dateCreated;
  }
  get dateLastUpdated(): Date {
    return this._props.dateLastUpdated;
  }
  get dateDeleted(): Date | null {
    return this._props.dateDeleted;
  }
  get lastUpdatedById(): string | null {
    return this._props.lastUpdatedById;
  }

  public get isMaintenance() {
    return this._props.humanErrorDamageType === HumanErrorDamageType.Maintenance;
  }
  public get isMedicalCrew() {
    return this._props.humanErrorDamageType === HumanErrorDamageType.MedicalCrew;
  }
  public get isPilot() {
    return this._props.humanErrorDamageType === HumanErrorDamageType.Pilot;
  }
  public get isClosed() {
    return this._props.status === OosTicketStatusType.Closed;
  }
  public get isDenied() {
    return this._props.status === OosTicketStatusType.Denied;
  }
  public get isDraft() {
    return this._props.status === OosTicketStatusType.Draft;
  }
  public get isProcessed() {
    return this._props.status === OosTicketStatusType.Processed;
  }
  public get isUnderReview() {
    return this._props.status === OosTicketStatusType.UnderReview;
  }
  public get isOpportunistic() {
    return this._props.outOfServiceType === OutOfServiceType.Opportunistic;
  }
  public get isRefurbishmentOrRefresh() {
    return this._props.outOfServiceType === OutOfServiceType.RefurbishmentOrRefresh;
  }
  public get isScheduled() {
    return this._props.outOfServiceType === OutOfServiceType.Scheduled;
  }
  public get isUnscheduled() {
    return this._props.outOfServiceType === OutOfServiceType.Unscheduled;
  }

  public isAnyHumanErrorDamageType(...humanErrorDamageType: HumanErrorDamageType[]) {
    return (
      this._props.humanErrorDamageType != null &&
      humanErrorDamageType.includes(this._props.humanErrorDamageType)
    );
  }
  public isAnyStatus(...oosTicketStatusType: OosTicketStatusType[]) {
    return oosTicketStatusType.includes(this._props.status);
  }
  public isAnyOutOfServiceType(...outOfServiceType: OutOfServiceType[]) {
    return (
      this._props.outOfServiceType != null &&
      outOfServiceType.includes(this._props.outOfServiceType)
    );
  }

  constructor(props: OutOfServiceTicketProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        id: this._props.id,
        ticketNumber: this._props.ticketNumber,
        businessUnitCompanyId: this._props.businessUnitCompanyId,
        isPlanned: this._props.isPlanned,
        maintenanceTypes: this._props.maintenanceTypes,
        vehicleId: this._props.vehicleId,
        assignedBaseId: this._props.assignedBaseId,
        maintenanceLocation: this._props.maintenanceLocation,
        outOfServiceTime: this._props.outOfServiceTime,
        ertsDateTime: this._props.ertsDateTime,
        submittedById: this._props.submittedById,
        dateSubmittedForReview: this._props.dateSubmittedForReview,
        pointOfContactId: this._props.pointOfContactId,
        alternatePOC: this._props.alternatePOC,
        ticketDescription: this._props.ticketDescription,
        spareVehicleId: this._props.spareVehicleId,
        isBirdStrike: this._props.isBirdStrike,
        isPatientOnboard: this._props.isPatientOnboard,
        opportunityMXTypes: this._props.opportunityMXTypes,
        mxDuringPeakTimeReason: this._props.mxDuringPeakTimeReason,
        waitingForParts: this._props.waitingForParts,
        waitingForTooling: this._props.waitingForTooling,
        waitingForPartsTimestamp: this._props.waitingForPartsTimestamp,
        waitingForToolingTimestamp: this._props.waitingForToolingTimestamp,
        isAMTAvailable: this._props.isAMTAvailable,
        isFAR135415Reportable: this._props.isFAR135415Reportable,
        isFAR135417Reportable: this._props.isFAR135417Reportable,
        acceptedById: this._props.acceptedById,
        dateAccepted: this._props.dateAccepted,
        humanErrorDamageType: this._props.humanErrorDamageType,
        qarReasons: this._props.qarReasons,
        rtsDelayReasonTypes: this._props.rtsDelayReasonTypes,
        pageoutCompletedById: this._props.pageoutCompletedById,
        datePageoutCompleted: this._props.datePageoutCompleted,
        status: this._props.status,
        primaryReasonId: this._props.primaryReasonId,
        secondaryReasonId: this._props.secondaryReasonId,
        outOfServiceType: this._props.outOfServiceType,
        dateAcknowledged: this._props.dateAcknowledged,
        acknowledgedById: this._props.acknowledgedById,
        acknowledgementNotes: this._props.acknowledgementNotes,
        maintenanceFacilityId: this._props.maintenanceFacilityId,
        locationId: this._props.locationId,
        address: this._props.address,
        isOpportunisticOOS: this._props.isOpportunisticOOS,
        companyId: this._props.companyId,
        dateLastUpdated: this._props.dateLastUpdated,
        dateCreated: this._props.dateCreated,
        dateDeleted: this._props.dateDeleted,
        lastUpdatedById: this._props.lastUpdatedById,
      };
    }
    return this._json;
  }
}

//#region Selectors

export const selectAllOutOfServiceTicketEntities = (state: AppState) =>
  state.entityStores.outOfServiceTicket.entities;

export const selectOutOfServiceTicketById = (id: string) => (state: AppState) =>
  state.entityStores.outOfServiceTicket.entities.get(id);

export const selectOutOfServiceTicketMetadataById = (id: string) => (state: AppState) =>
  state.entityStores.outOfServiceTicket.meta.get(id);

export const selectOutOfServiceTicketAndMetadataById = (id: string) =>
  createSelector(
    selectOutOfServiceTicketById(id),
    selectOutOfServiceTicketMetadataById(id),
    (outOfServiceTicket, meta) => ({ outOfServiceTicket, meta }),
  );

export function selectOutOfServiceTicketEntitiesByIds(ids: string[]) {
  return createSelector(
    selectAllOutOfServiceTicketEntities,

    (entities) => {
      // TODO: Once we're on TS 3.5+, I don't think we'll need use type assertions
      const entries = ids.map((id) => [id, entities.get(id)]) as unknown as Iterable<
        [string, OutOfServiceTicketRecord | undefined]
      >;
      return Map(entries);
    },
  );
}

export function selectOutOfServiceTicketEntitiesByTicketNumber(ticketNumber: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.ticketNumber === ticketNumber).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByBusinessUnitCompanyId(
  businessUnitCompanyId: string,
) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.businessUnitCompanyId === businessUnitCompanyId).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByIsPlanned(isPlanned: boolean) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.isPlanned === isPlanned).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByVehicleId(vehicleId: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.vehicleId === vehicleId).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByAssignedBaseId(assignedBaseId: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.assignedBaseId === assignedBaseId).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByMaintenanceLocation(maintenanceLocation: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.maintenanceLocation === maintenanceLocation).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByOutOfServiceTime(outOfServiceTime: Date) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.outOfServiceTime === outOfServiceTime).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByErtsDateTime(ertsDateTime: Date) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.ertsDateTime === ertsDateTime).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesBySubmittedById(submittedById: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.submittedById === submittedById).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByDateSubmittedForReview(
  dateSubmittedForReview: Date,
) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.dateSubmittedForReview === dateSubmittedForReview).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByPointOfContactId(pointOfContactId: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.pointOfContactId === pointOfContactId).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByAlternatePOC(alternatePOC: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.alternatePOC === alternatePOC).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByTicketDescription(ticketDescription: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.ticketDescription === ticketDescription).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesBySpareVehicleId(spareVehicleId: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.spareVehicleId === spareVehicleId).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByIsBirdStrike(isBirdStrike: boolean) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.isBirdStrike === isBirdStrike).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByIsPatientOnboard(isPatientOnboard: boolean) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.isPatientOnboard === isPatientOnboard).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByMxDuringPeakTimeReason(
  mxDuringPeakTimeReason: string,
) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.mxDuringPeakTimeReason === mxDuringPeakTimeReason).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByWaitingForParts(waitingForParts: boolean) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.waitingForParts === waitingForParts).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByWaitingForTooling(waitingForTooling: boolean) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.waitingForTooling === waitingForTooling).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByWaitingForPartsTimestamp(
  waitingForPartsTimestamp: Date,
) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.waitingForPartsTimestamp === waitingForPartsTimestamp).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByWaitingForToolingTimestamp(
  waitingForToolingTimestamp: Date,
) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.waitingForToolingTimestamp === waitingForToolingTimestamp).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByIsAMTAvailable(isAMTAvailable: boolean) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.isAMTAvailable === isAMTAvailable).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByIsFAR135415Reportable(
  isFAR135415Reportable: boolean,
) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.isFAR135415Reportable === isFAR135415Reportable).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByIsFAR135417Reportable(
  isFAR135417Reportable: boolean,
) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.isFAR135417Reportable === isFAR135417Reportable).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByAcceptedById(acceptedById: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.acceptedById === acceptedById).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByDateAccepted(dateAccepted: Date) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.dateAccepted === dateAccepted).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByHumanErrorDamageType(
  humanErrorDamageType: HumanErrorDamageType,
) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.humanErrorDamageType === humanErrorDamageType).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByPageoutCompletedById(
  pageoutCompletedById: string,
) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.pageoutCompletedById === pageoutCompletedById).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByDatePageoutCompleted(datePageoutCompleted: Date) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.datePageoutCompleted === datePageoutCompleted).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByStatus(status: OosTicketStatusType) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.status === status).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByPrimaryReasonId(primaryReasonId: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.primaryReasonId === primaryReasonId).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesBySecondaryReasonId(secondaryReasonId: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.secondaryReasonId === secondaryReasonId).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByOutOfServiceType(
  outOfServiceType: OutOfServiceType,
) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.outOfServiceType === outOfServiceType).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByDateAcknowledged(dateAcknowledged: Date) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.dateAcknowledged === dateAcknowledged).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByAcknowledgedById(acknowledgedById: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.acknowledgedById === acknowledgedById).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByAcknowledgementNotes(
  acknowledgementNotes: string,
) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.acknowledgementNotes === acknowledgementNotes).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByMaintenanceFacilityId(
  maintenanceFacilityId: string,
) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.maintenanceFacilityId === maintenanceFacilityId).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByLocationId(locationId: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.locationId === locationId).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByIsOpportunisticOOS(isOpportunisticOOS: boolean) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.isOpportunisticOOS === isOpportunisticOOS).valueSeq(),
  );
}

export function selectOutOfServiceTicketEntitiesByCompanyId(companyId: string) {
  return createSelector(selectAllOutOfServiceTicketEntities, (entities) =>
    entities.filter((e) => e.companyId === companyId).valueSeq(),
  );
}
//#endregion Selectors
